import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import { lightOrDark } from "../../../Base/Utilities/LightOrDark";
import { getEventTranslationKey } from "../../../Base/Utilities/TranslationHelper";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails.jsx";

const DeleteListItem = (props) => {
  const { currentState, event, intl } = props;
  const { formatMessage } = intl;
  const [detailsText, setDetailsText] = useState();
  const [team, setTeam] = useState();
  const [player, setPlayer] = useState();
  const { sport } = useContext(FixtureDetailsContext);

  useEffect(() => {
    if (!event) {
      return;
    }

    setTeam(
      currentState.entities.find((el) => el.entityId === event.entityId)
    );

    setDetailsText(getEventTranslationKey(event, sport));
    // eslint-disable-next-line
  }, [event]);

  useEffect(() => {
    if (team) {
      setPlayer(team.persons.find((el) => el.personId === event.personId));
    }
    // eslint-disable-next-line
  }, [team]);

  return (
    <div className="event">
      {detailsText && (
        <React.Fragment>
          <span className="event-type">
            <span
              className={
                "player-bib " + (team ? lightOrDark(team.primaryColor) : "dark")
              }
              style={{
                backgroundColor: team ? team.primaryColor : "#eee",
              }}
            >
              {player && player.bib ? player.bib : "-"}
            </span>
            <span className="event-details">
              {formatMessage({
                id: detailsText,
                defaultMessage: detailsText,
              })}
            </span>
            {player && (
              <span className="event-player">
                <span>({player.name})</span>
              </span>
            )}
          </span>
        </React.Fragment>
      )}
    </div>
  );
};

export default injectIntl(DeleteListItem);
